import axios from 'axios'
import { Invoice, InvoiceDetail, MailQueue, DepositAmount} from '@/domain/Invoice'
import { SendMail } from '@/domain/SendMail'

/**
 * 検索条件
 */
export class SerchConditon {
    /** 請求番号 */
    invoiceNo = ""
    /** 期間開始日 */
    startOn = ""
    /** 期間終了日 */
    endOn = ""
    /** 顧客都道府県コード */
    customerPrefectureCode = ""
    /** 顧客コード */
    customerCode = ""
    /** 顧客枝番 */
    customerBranchNumber = ""
    /** 顧客名 */
    customerName = ""
    /** 検査依頼種別 */
    requestType: number | null = null
    /** 検査依頼の備考 */
    requestNote = ""
    /** 入金状態：入金済み */
    paymentStatusDeposited = false
    /** 入金状態：未入金 */
    paymentStatusNotPayment = false
    /** 入金状態：過不足あり */
    paymentStatusExcessOrDeficiency = false
    /* 有効 */
    isActive = true

    /* 画面用 */
    /** 期間タイプ */
    dateType = 3

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<SerchConditon>) {
        Object.assign(this, init)
    }
}

/**
 * 請求サービス
 */
export default class InvoicesService {
    /** インスタンス */
    private static _instance: InvoicesService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new InvoicesService();
        }
        return this._instance;
    }

    /**
     * 新規作成
     */
    public async createNew(): Promise<Invoice> {
        return await axios.get("/api/invoice/new")
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            // eslint-disable-next-line
            .catch((error) => {
                throw error
            })
    }
    
    /**
     * 参照新規作成
     */
    public async referenceNew(requestNos: string[]): Promise<Invoice> {
        const params = requestNos.map(x => `requestNos=${x}`).join("&")
        return await axios.get(`/api/invoice/new?${params}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            // eslint-disable-next-line
            .catch((error) => {
                throw error
            })
    }

    /**
     * 編集
     */
    public async edit(no: string): Promise<Invoice> {
        return await axios.get(`/api/invoice/edit/${no}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    public async  createchk(dto: Invoice): Promise<number> {
        return await axios.post("/api/invoice/newchk", dto)
            .then((results) => {
                if (results.status === 200) {
                    return results.data
                } else {
                    throw results.statusText
                }
            })
            // eslint-disable-next-line
            .catch((error) => {
                throw error
            })
    }



    /**
     * 新規保存
     */
    public async create(dto: Invoice): Promise<Invoice> {
        if (dto.maturity === null) {
            dto.maturity = ""
        }
        return await axios.post("/api/invoice/new", dto)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 保存
     */
    public async update(dto: Invoice): Promise<Invoice> {
        if (dto.maturity === null) {
            dto.maturity = ""
        }
        return await axios.put(`/api/invoice/edit/${dto.invoiceNo}`, dto)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }


    /**
     * 保存 枝番発番
     */
    public async brUpdate(dto: Invoice): Promise<Invoice> {
        if (dto.maturity === null) {
            dto.maturity = ""
        }
        return await axios.put(`/api/invoice/bredit/${dto.invoiceNo}`, dto)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 削除
     */
    public async delete(no: string): Promise<Invoice> {
        return await axios.delete(`/api/invoice/delete/${no}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 印刷
     */
    public async print(no: string): Promise<Invoice> {
        return await axios.put(`/api/invoice/print/${no}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 複数の請求に対する請求明細を取得
     */
    public async getDetails(invoiceNos: string[]): Promise<InvoiceDetail[]> {
        const params = invoiceNos.map(x => `invoiceNos=${x}`).join("&")
        return await axios.get(`/api/invoice/details?${params}`)
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as InvoiceDetail[]).map(x => new InvoiceDetail({ ...x }))
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

     /**
     * 請求一覧を検索
     */
    public async findAll(serchConditon: SerchConditon): Promise<Invoice[]> {
        return await axios.get("/api/invoices", {params: serchConditon})
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as Invoice[]).map(x => this.convert(x))
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * メール送信テンプレートの取得
     */
    public async generateMailTemplate(nos: string[]): Promise<SendMail> {
        const params = nos.map(x => `no=${x}`).join("&")
        return await axios.get(`/api/invoices/generate_mail_template?${params}`)
            .then((results) => {
                if (results.status === 200) {
                    const sendMail = results.data as SendMail
                    return new SendMail({ ...sendMail })
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * メール送信キューへの登録
     */
    public async mailQueuePush(mailQueue: MailQueue): Promise<MailQueue> {
        return await axios.post("/api/invoices/mail_queue_push", mailQueue)
            .then((results) => {
                if (results.status === 200) {
                    return results.data as MailQueue
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 入金
     */
    public async depositAmount(depositAmounts: DepositAmount[]): Promise<Invoice[]> {
        return await axios.put("/api/invoices/deposit_amounts", depositAmounts)
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as Invoice[]).map(x => this.convert(x))
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 受信データの変換
     * @param data
     */
    // eslint-disable-next-line
    private convert(data: any): Invoice {
        const invoice = data as Invoice
        invoice.importInfo.samplingOn = invoice.importInfo.samplingOn || ""
        invoice.importInfo.arrivalOn = invoice.importInfo.arrivalOn || ""
        return new Invoice({ ...invoice })
    }
}
